<script setup lang="ts">
import type { IDrawerImageBlockProps } from '../types'

const props = defineProps<IDrawerImageBlockProps>()
</script>

<template>
    <section>
        <VDivider
            v-if="props.topDivider"
            class="mb-6 mt-2"
        />

        <div>
            <BaseImage
                :image-data="image"
                :alt="alt"
                class="rounded-container-lg"
            />
        </div>
    </section>
</template>
